// import { getMerchnatVersionFromStore } from '../../../../lib/helper';

// const merchantVersion = getMerchnatVersionFromStore();

export const DASHBOARD_DEFAULT_THEME_COLOR = '#1b3a2d';

export const SETTINGS_TABS_LINKS = {
  credentials: { label: 'Credentials', value: 'credentials' },
  webhook: { label: 'Webhook', value: 'webhook' },
  paymentLinksWebhook: {
    label: 'Payment Links Webhook',
    value: 'paymentLinksWebhook',
  },
  customization: { label: 'Customization', value: 'customization' },
  checkoutTheme: { label: 'Checkout Styling', value: 'checkoutTheme' },
  expressCheckout: { label: 'Express Checkout', value: 'expressCheckout' },
  paymentModes: {
    label: 'Payment Modes', value: 'paymentModes',
  },
  splitSettlement: { label: 'Split settlement config', value: 'splitSettlement' },
};

export const MERCHANT_VERSION = {
  V3: 'V3',
  V2:'V2',
  V31: 'V31'
}; 

export const getSettingTabs = (
  isPaymentLink: boolean,
  isAdmin: boolean,
  merchantVersion: string ,
  isSelfServe: any,
  appleWalletStatus: any,
  isParentMerchant = false,
): { [index: string]: { label: string; value: string } } => {

  return {
    credentials: { label: 'Credentials', value: 'credentials' },
    webhook: { label: 'Webhook', value: 'webhook' },
    checkoutTheme: { label: 'Checkout Styling', value: 'checkoutTheme' },
    expressCheckout: { label: 'Express Checkout', value: 'expressCheckout' },
    ...(merchantVersion !== MERCHANT_VERSION.V3 && isPaymentLink
      ? {
          paymentLinksWebhook: {
            label: 'Payment Links Webhook',
            value: 'paymentLinksWebhook',
          },
        }
      : {}),
    ...(isAdmin
      ? { customization: { label: 'Customization', value: 'customization' },
    }
      : {}),
    paymentModes: { label: 'Payment Modes', value: 'paymentModes' },
    ...(isParentMerchant
      ? { splitSettlement: { label: 'Split settlement config', value: 'splitSettlement' } }
      : {}),
  };
};
